<template>
    <div class="accoutNumberAdmin">
        <content-header>
            <div class="header-left" slot="header-left">
                <el-select v-model="seachData.schemeId" :placeholder="$t('accoutNumberAdmin.QXZ')" size="small" @change="getList">
                    <div class="prefix" slot="prefix">{{$t('accoutNumberAdmin.LXJH')}}</div>
                    <el-option :label="$t('accoutNumberAdmin.QB')" value=""></el-option>
                    <el-option v-for="item in schemeList" :key="item.id" :label="item.schemeName" :value="item.id"></el-option>
                </el-select>
            </div>
            <div class="header-right" slot="header-right">
                <el-input 
                    v-model="seachData.searchContent" 
                    @keyup.enter.native="getList"
                    class="seach-input"
                    :placeholder="$t('accoutNumberAdmin.QSRXMHZH')"
                    size="small">
                    <span slot="suffix" @click="getList" class="el-icon-search input-seach"></span>
                </el-input>
                <el-button 
                    type="primary"
                    @click="()=>{deletePlayer('all')}"
                    size="small"> 
                    {{$t('accoutNumberAdmin.PLSC')}}
                </el-button>
                <el-button 
                    type="primary"
                    @click="createdAccout"
                    size="small"> 
                    {{$t('accoutNumberAdmin.SCZH')}}
                </el-button>
                <el-button 
                    type="primary"
                    :loading="buttonsLoading"
                    style="margin-right: 0"
                    @click="accountExport"
                    size="small"> 
                    {{$t('accoutNumberAdmin.DC')}}
                </el-button>
            </div>
        </content-header>
        <div class="main" v-loading="loading">
            <c-table
                @operation="operation" 
                :tableData="playerList" 
                :tableHeader="teamTableHeader" 
                :TableHeight="`calc( 100vh - ${total > 100 ? 240 : 190}px )`">
            </c-table>
            <paging 
                :total="total"
                @currentChange="(pageNo)=>{this.pageNo = pageNo; getList('pageNo')}" 
                :pageNo="pageNo">
            </paging>
        </div>
        <dialog-lx v-bind.sync="dialogData" @saveClick="()=>{ createdAccout('next') }">
            <div class="content-main">
                <p><span class="form-name">{{$t('accoutNumberAdmin.XZGLSSLXJH')}}</span></p>
                <el-select 
                    v-model="dialogData.formData.schemeId" 
                    :placeholder="$t('accoutNumberAdmin.QXZGLSSLXJH')" size="small"
                    @change="schemeChage"
                >
                    <el-option v-for="item in schemeList" :key="item.id" :label="item.schemeName" :value="item.id"></el-option>
                </el-select>
                <p><span class="form-name">{{$t('accoutNumberAdmin.SCZHGS')}}</span></p>
                <el-input
                    style="width: 100%"
                    :placeholder="$t('accoutNumberAdmin.QSRSCZHGS')"
                    v-model.number="dialogData.formData.accountCount"
                    size="small"
                    maxlength="10"
                    @focus="() => {dialogData.buttonLoading = false}"
                >
                </el-input>
                <p class="count_number">{{$t('accoutNumberAdmin.NDQJHZKYSC')}} {{ dialogData.accountCount }}</p>
            </div>
        </dialog-lx>
    </div>
</template>
<script>
import CTable from '@/components/table'
import mins from './mins'
import dialogLx from '@/components/dialog-lx'
import paging from '@/components/paging'
export default {
    name: 'accoutNumberAdmin',
    mixins: [mins],
    components: {CTable,dialogLx,paging}
}
</script>
<style scoped lang="scss">
.accoutNumberAdmin{
    height: 100%;
    width: 100%;
    .main{
        box-sizing: border-box;
        padding: 12px 24px 0;
        width: 100%;
    }
    .content-main{
        .form-name{
            @include fontstyle(14px, #606266, 400);
            @include userselect();
        }
        .count_number{
            color: #BCBCBC;
            font-size: 12px;
        }
        /deep/ .el-select{
            width: 100%;
        }
    }
    .header-right, .header-left{
         /deep/ .el-button{
            margin-right: 8px;
        }
        /deep/ .el-input .input-seach{
            vertical-align: -7px;
        }
        /deep/ .el-input.seach-input{
            width: 260px;
            height: 32px;
            margin: 0 16px;
            opacity: 1;
            border-radius: 2px;
            .el-input__inner{
                background: #F1F2F4;
            }
        }
        /deep/ .el-select{
            height: 32px;
            border-radius: 2px;
            .el-input__inner{
                background: #F1F2F4;
                padding-left: 112px;
                box-sizing: border-box;
            }
            
        }
        /deep/ .el-input{
            min-width: 320px;
            height: 32px;
            
            opacity: 1;
            border-radius: 2px;
            .el-input__inner{
                background: #F1F2F4;
            }
        }
        .prefix{
            height: 20px;
            font-size: 12px;
            font-family: Hiragino Sans GB;
            font-weight: normal;
            line-height: 20px;
            padding: 0 4px;
            margin-top: 7px;
            border-right: solid #ccc 1px;
            color: #A0A0A6;
            -webkit-text-stroke: 1 rgba(255, 255, 255, 0);
            letter-spacing: 1px;
        }
    }
    
}
</style>